import Seo from "../common/Seo.js";
import PatchNotes from "../community/PatchNotes.js";

export default function PublicPatchNotesPage() {
  return (
    <>
      <Seo
        title="Patch Notes | Age of Companies"
        description="Read the latest Age of Companies updates, new features, gameplay changes, and fixes."
        path="/patch-notes"
      />
      <main id="main-content" className="public-patch-notes">
        <PatchNotes />
      </main>
    </>
  );
}
